import React from 'react'

import AutoParts from '../../icons/auto_parts.png'

import './about-us.css'

const AboutUs = () => (
  <section className='about-us flex-container--bottom-70'>
    <div className='section__content flex-container'>
      <div className='about-us__content'>
        <div className='about-us__title'>Доставка запчастин з Польщі, з Allegro.pl</div>
        <div className='about-us__description'>
          Компанія X-PART працює на ринку з 2017 року і спеціалізується в сегменті запчастин до транспортних засобів іноземного виробництва. З перших днів своєї роботи компанія надає клієнтам максимально якісний та зручний сервіс з підбору та доставки необхідних запчастин з Європи, а також консультації кваліфікованих фахівців, оптимальні ціни та асортимент, що постійно оновлюється.
        </div>
      </div>
      <img src={AutoParts} alt='' width={481} height={466} />
    </div>
  </section>
)

export default AboutUs
